/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import * as AppPropTypes from '../../lib/PropTypes';
import Button from './Button';
import ArrowIcon from '../icons/Arrow';
import LoadingIcon from '../icons/Loading';

import styles from '../../../styles/buttons/arrow.module.scss';

const propTypes = {
    direction: AppPropTypes.arrowDirection,
    link: PropTypes.string,
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    isDark: PropTypes.bool, // eslint-disable-line react/no-unused-prop-types
    color: PropTypes.string,
    backgroundColor: PropTypes.string,
    IconComponent: PropTypes.func,
    className: PropTypes.string,
    iconClassName: PropTypes.string,
    onClick: PropTypes.func,
    type: PropTypes.string,
};

const defaultProps = {
    direction: 'right',
    link: null,
    loading: false,
    disabled: false,
    isDark: false,
    color: 'currentColor',
    backgroundColor: 'transparent',
    IconComponent: ArrowIcon,
    className: null,
    iconClassName: null,
    onClick: null,
    type: null,
};

const Arrow = ({
    direction,
    link,
    loading,
    disabled,
    color,
    backgroundColor,
    IconComponent,
    className,
    iconClassName,
    onClick,
    type,
}) => (
    <Button
        href={link}
        onClick={onClick}
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
            },
        ])}
        disabled={disabled || loading}
    >
        {loading ? (
            <LoadingIcon color={color} backgroundColor={backgroundColor} className={styles.icon} />
        ) : (
            <IconComponent
                direction={direction}
                color={color}
                backgroundColor={backgroundColor}
                className={classNames([
                    styles.icon,
                    {
                        [iconClassName]: iconClassName !== null,
                    },
                ])}
                type={type}
            />
        )}
    </Button>
);

Arrow.propTypes = propTypes;
Arrow.defaultProps = defaultProps;

export default Arrow;
